/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsorderpaid2Inputs */

const en_ticketsorderpaid2 = /** @type {(inputs: Ticketsorderpaid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paid`)
};

const de_ticketsorderpaid2 = /** @type {(inputs: Ticketsorderpaid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezahlt`)
};

/**
* | output |
* | --- |
* | "Paid" |
*
* @param {Ticketsorderpaid2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsorderpaid2 = /** @type {((inputs?: Ticketsorderpaid2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsorderpaid2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsorderpaid2(inputs)
	return de_ticketsorderpaid2(inputs)
});
export { ticketsorderpaid2 as "ticketsOrderPaid" }